// extracted by mini-css-extract-plugin
export default {"wrapper":"carrier-handoff-module__wrapper--Xbz","logo":"carrier-handoff-module__logo--yfm"};